import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles(({ palette, colors, breakpoints }: Theme) => createStyles({
  titleContainer: {
    margin: '74px 0 80px 0',
    textAlign: 'center',
    width: '100%',

    [breakpoints.down('sm')]: {
      margin: '24px 0 40px 0',
    },

    [breakpoints.down('xs')]: {
      margin: '14px 0 30px 0',
    },
  },
  title: {
    fontFamily: 'Montserrat',
    fontSize: '36px',
    letterSpacing: '0.3px',
    color: '#26325F',

    [breakpoints.down('sm')]: {
      fontSize: '32px',
    },

    [breakpoints.down('xs')]: {
      fontSize: '28px',
    },
  },
  description: {
    margin: 0,
    fontFamily: 'Montserrat',
    fontSize: 22,
    letterSpacing: '0.29px',
    color: '#263245',
    fontWeight: 500,

    [breakpoints.down(450)]: {
      fontSize: 18,
    },
  },
}), { name: 'PricingPageTitle' });

export default useStyles;
